import { Add } from '@mui/icons-material';
import { Box, Button, Paper, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';


interface IToolsCompanyProps {
    showNewButton?: boolean;
}



export const ToolsCompany:React.FC<IToolsCompanyProps> = ({
    showNewButton = true,
}) => {

    // const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    // const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    const theme = useTheme();
    const navigate = useNavigate();


    return(
        <Box 
        component={Paper}
        height={theme.spacing(4)}
        marginX={1}
        paddingX={2}
        padding={1}
        display={'flex'}
        gap={2}
        alignItems={'center'}
        borderRadius={2}
        >
            {(showNewButton) &&(<Button
                variant='contained'
                disableElevation
                onClick={() => navigate('./company_registration/novo')}
                startIcon={<Add />}
                sx={{borderRadius: '25px'}}
            >
                <Typography
                    variant='button'
                    whiteSpace={'nowrap'}
                    textOverflow={'ellipsis'}
                    overflow={'hidden'}
                    color={'white'}
                >
                    Nova
                </Typography>
            </Button>)}
            {/* {mostrarBotaoSalvarCarregando &&(<Skeleton width={108} height={62}/>)} */}
        </Box>
    );
};